import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	successfulDeploymentsHeading: {
		id: 'automation-platform.automation-recommendation.explainer-section.successful-deployments-heading',
		defaultMessage: 'Move issues to done for successful deployments',
		description: 'Explains what the automation recommendation will do once configured',
	},
	failedDeploymentsHeading: {
		id: 'automation-platform.automation-recommendation.explainer-section.failed-deployments-heading',
		defaultMessage: 'Notify your team about failed deployments',
		description: 'Explains what the automation recommendation will do once configured',
	},
	versionsCreatedHeading: {
		id: 'automation-platform.automation-recommendation.explainer-section.versions-created-heading',
		defaultMessage: 'Create feature flags for assigned versions',
		description: 'Explains what the automation recommendation will do once configured',
	},
	criticalVulnerabilitiesHeading: {
		id: 'automation-platform.automation-recommendation.explainer-section.critical-vulnerabilities-heading',
		defaultMessage: 'Create issues for security vulnerabilities',
		description: 'Explains what the automation recommendation will do once configured',
	},
	successfulDeploymentsDescription: {
		id: 'automation-platform.automation-recommendation.explainer-section.successful-deployments-description',
		defaultMessage:
			'We found issues with successful deployments for this project. Create a rule to automatically move issues to done.',
		description: 'Explains to the user why are we showing this recommendation',
	},
	failedDeploymentsDescription: {
		id: 'automation-platform.automation-recommendation.explainer-section.failed-deployments-description',
		defaultMessage:
			'We found issues with failed deployments in this project. Create a rule to automatically notify the right people when this happens.',
		description: 'Explains to the user why are we showing this recommendation',
	},
	versionsCreatedDescription: {
		id: 'automation-platform.automation-recommendation.explainer-section.versions-created-description',
		defaultMessage:
			'We found issues with assigned versions for this project. Create a rule to automatically create feature flags.',
		description: 'Explains to the user why are we showing this recommendation',
	},
	criticalVulnerabilitiesDescription: {
		id: 'automation-platform.automation-recommendation.explainer-section.critical-vulnerabilities-description',
		defaultMessage:
			'We found security vulnerabilities in this project. Create a rule to automatically create issues.',
		description: 'Explains to the user why are we showing this recommendation',
	},
	successfulDeploymentsHeadingIssueTerminologyRefreshM4: {
		id: 'automation-platform.automation-recommendation.explainer-section.successful-deployments-heading-issue-terminology-refresh-m4',
		defaultMessage: 'Move work items to done for successful deployments',
		description: 'Explains what the automation recommendation will do once configured',
	},
	criticalVulnerabilitiesHeadingIssueTerminologyRefreshM4: {
		id: 'automation-platform.automation-recommendation.explainer-section.critical-vulnerabilities-heading-issue-terminology-refresh-m4',
		defaultMessage: 'Create work items for security vulnerabilities',
		description: 'Explains what the automation recommendation will do once configured',
	},
	successfulDeploymentsDescriptionIssueTerminologyRefreshM4: {
		id: 'automation-platform.automation-recommendation.explainer-section.successful-deployments-description-issue-terminology-refresh-m4',
		defaultMessage:
			'We found work items with successful deployments for this project. Create a rule to automatically move work items to done.',
		description: 'Explains to the user why are we showing this recommendation',
	},
	failedDeploymentsDescriptionIssueTerminologyRefreshM4: {
		id: 'automation-platform.automation-recommendation.explainer-section.failed-deployments-description-issue-terminology-refresh-m4',
		defaultMessage:
			'We found work items with failed deployments in this project. Create a rule to automatically notify the right people when this happens.',
		description: 'Explains to the user why are we showing this recommendation',
	},
	versionsCreatedDescriptionIssueTerminologyRefreshM4: {
		id: 'automation-platform.automation-recommendation.explainer-section.versions-created-description-issue-terminology-refresh-m4',
		defaultMessage:
			'We found work items with assigned versions for this project. Create a rule to automatically create feature flags.',
		description: 'Explains to the user why are we showing this recommendation',
	},
	criticalVulnerabilitiesDescriptionIssueTerminologyRefreshM4: {
		id: 'automation-platform.automation-recommendation.explainer-section.critical-vulnerabilities-description-issue-terminology-refresh-m4',
		defaultMessage:
			'We found security vulnerabilities in this project. Create a rule to automatically create work items.',
		description: 'Explains to the user why are we showing this recommendation',
	},
});
